export const ROLES = {
    ADMIN: ['ROLE_AGENDA_EXTERNA_FULL_ACCESS'],
    USER: ['ROLE_AGENDA_EXTERNA_LIMITED_ACCESS'],
    FORNECEDOR: ['ROLE_AGENDA_EXTERNA_FORNECEDOR'],
    TRASPORTADORA: ['ROLE_AGENDA_EXTERNA_TRASPORTADORA'],
    PRE_AGENDAMENTO: ['ROLE_AGENDA_EXTERNA_PRE_AGENDAMENTO']
}
